@import "tailwindcss";
@import "./styles/linear-squadra.css";
@import "leaflet/dist/leaflet.css";

:root {
  color-scheme: light;

  /* Palette neutra */
  --c-bg:           #e6ebf3;
  --c-surface:      #ffffff;
  --c-border:       #cdd4e2;
  --c-border-strong:#aeb8cc;

  --c-text-900: #0f172a;
  --c-text-700: #374151;
  --c-text-500: #6b7280;
  --c-text-400: #9ca3af;

  /* Semaforo verde */
  --c-verde-50:  #edfaf3;
  --c-verde-100: #d1f5e3;
  --c-verde-200: #a4ebca;
  --c-verde-300: #5ecf99;
  --c-verde-500: #2e9f5c;
  --c-verde-600: #1e7a45;
  --c-verde-700: #145c32;
  --c-verde-900: #0a3a1e;

  /* Amber (da terminare) */
  --c-amber-50:  #fffbeb;
  --c-amber-100: #fef3c7;
  --c-amber-300: #fcd34d;
  --c-amber-500: #f59e0b;
  --c-amber-600: #d97706;
  --c-amber-700: #b45309;
  --c-amber-900: #78350f;

  /* Rosso */
  --c-rosso-50:  #fff1f2;
  --c-rosso-100: #ffe4e6;
  --c-rosso-500: #ef4444;
  --c-rosso-600: #dc2626;
  --c-rosso-700: #b91c1c;

  /* Blu info */
  --c-blu-50:  #eff6ff;
  --c-blu-500: #3b82f6;
  --c-blu-700: #1d4ed8;

  /* Alias legacy (per compatibilità JSX esistente) */
  --semaforo-dark-50:   var(--c-bg);
  --semaforo-dark-100:  var(--c-border);
  --semaforo-dark-200:  var(--c-border-strong);
  --semaforo-dark-400:  var(--c-text-400);
  --semaforo-dark-500:  var(--c-text-500);
  --semaforo-dark-600:  var(--c-text-700);
  --semaforo-dark-700:  var(--c-text-700);
  --semaforo-dark-800:  #1f2937;
  --semaforo-dark-900:  var(--c-text-900);
  --semaforo-verde-50:  var(--c-verde-50);
  --semaforo-verde-500: var(--c-verde-500);
  --semaforo-verde-700: var(--c-verde-600);
  --semaforo-verde-900: var(--c-verde-900);
  --semaforo-rosso-50:  var(--c-rosso-50);
  --semaforo-rosso-500: var(--c-rosso-500);
  --semaforo-rosso-700: var(--c-rosso-700);
  --semaforo-arancio-500: var(--c-amber-500);
}

/* ── Reset base ─────────────────────────────────────── */
html { font-size: 16px; -webkit-text-size-adjust: 100%; }
body {
  margin: 0;
  min-height: 100dvh;
  background: var(--c-bg);
  color: var(--c-text-900);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif;
}
* { box-sizing: border-box; }
* { -webkit-tap-highlight-color: transparent; }
input, textarea, select, button { font: inherit; }
button { cursor: pointer; }

/* ── Palette utilities (JSX compat) ─────────────────── */
.bg-semaforo-dark-50       { background-color: var(--c-bg); }
.bg-semaforo-dark-100      { background-color: var(--c-border); }
.bg-semaforo-dark-800      { background-color: #1f2937; }
.text-semaforo-dark-900    { color: var(--c-text-900); }
.text-semaforo-dark-800    { color: #1f2937; }
.text-semaforo-dark-700    { color: var(--c-text-700); }
.text-semaforo-dark-600    { color: var(--c-text-700); }
.text-semaforo-dark-500    { color: var(--c-text-500); }
.text-semaforo-dark-400    { color: var(--c-text-400); }
.border-semaforo-dark-100  { border-color: var(--c-border); }
.border-semaforo-dark-200  { border-color: var(--c-border-strong); }
.bg-semaforo-verde-50      { background-color: var(--c-verde-50); }
.bg-semaforo-verde-500     { background-color: var(--c-verde-500); }
.text-semaforo-verde-700   { color: var(--c-verde-600); }
.text-semaforo-verde-800   { color: var(--c-verde-700); }
.text-semaforo-verde-900   { color: var(--c-verde-900); }
.border-semaforo-verde-200 { border-color: var(--c-verde-200); }
.border-semaforo-verde-300 { border-color: var(--c-verde-200); }
.border-semaforo-verde-400 { border-color: var(--c-verde-300); }
.border-semaforo-verde-500 { border-color: var(--c-verde-500); }
.hover\:bg-semaforo-verde-100:hover { background-color: var(--c-verde-100); }
.bg-semaforo-rosso-50      { background-color: var(--c-rosso-50); }
.bg-semaforo-rosso-500     { background-color: var(--c-rosso-500); }
.text-semaforo-rosso-700   { color: var(--c-rosso-700); }
.bg-semaforo-arancio-500   { background-color: var(--c-amber-500); }
.text-semaforo-arancio-500 { color: var(--c-amber-500); }

/* ── Card sezione ───────────────────────────────────── */
.card-section {
  border: 1px solid var(--ln-border, rgba(15, 23, 42, 0.14));
  border-radius: 12px;
  background: linear-gradient(180deg, #ffffff 0%, #fbfcff 100%);
  box-shadow: var(--ln-shadow-card, 0 1px 3px rgba(15, 23, 42, 0.05), 0 6px 16px -3px rgba(15, 23, 42, 0.07));
  padding: 1.125rem;
  overflow: hidden;
}
@media (min-width: 768px) { .card-section { padding: 1.35rem; } }

/* ── Tipografia ─────────────────────────────────────── */
.page-title {
  font-size: clamp(1.375rem, 3.5vw, 2rem);
  line-height: 1.15;
  font-weight: 800;
  letter-spacing: -0.025em;
  color: var(--c-text-900);
}
.section-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.875rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--ln-border-subtle, rgba(0, 0, 0, 0.08));
  font-size: 0.95rem;
  font-weight: 800;
  color: var(--ln-text-primary, #0f172a);
  letter-spacing: -0.01em;
}
.label {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--ln-text-secondary, #334155);
}

.input {
  width: 100%;
  border: 1px solid var(--ln-border, rgba(0, 0, 0, 0.12));
  border-radius: 8px;
  background: var(--ln-surface, #ffffff);
  color: var(--ln-text-primary, #0f172a);
  padding: 0.75rem 0.875rem;
  outline: none;
  font-size: 0.95rem;
  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.03);
  transition: box-shadow 150ms ease, border-color 150ms ease;
}
.input.pl-10, .input.\!pl-10, .input.pl-11, .input.\!pl-11 { padding-left: 2.75rem !important; }
.input.pr-10, .input.\!pr-10, .input.pr-11, .input.\!pr-11 { padding-right: 2.75rem !important; }
.input::placeholder { color: var(--ln-text-subtle, #94a3b8); }
.input:focus {
  border-color: var(--ln-accent, #5e6ad2);
  box-shadow: 0 0 0 3px var(--ln-accent-subtle, rgba(94, 106, 210, 0.1));
}

/* ── Pulsanti ───────────────────────────────────────── */
.btn, .btn-primary, .btn-secondary, .btn-outline, .btn-ghost, .btn-danger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border-radius: 1rem;
  padding: 0.8125rem 1.125rem;
  font-size: 0.9375rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  transition: transform 120ms ease, opacity 140ms ease, background-color 150ms ease, box-shadow 150ms ease;
  user-select: none;
  white-space: nowrap;
}
.btn:active, .btn-primary:active, .btn-secondary:active,
.btn-outline:active, .btn-ghost:active, .btn-danger:active { transform: scale(0.97); }
.btn:disabled, .btn-primary:disabled, .btn-secondary:disabled,
.btn-outline:disabled, .btn-ghost:disabled, .btn-danger:disabled { opacity: 0.5; cursor: not-allowed; }

.btn-primary {
  background: var(--ln-accent, #5e6ad2);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}
.btn-primary:hover:not(:disabled) { background: var(--ln-accent-hover, #4f58b5); }

.btn-secondary {
  background: var(--ln-surface-elevated, #f1f5f9);
  color: var(--ln-text-primary, #0f172a);
  border: 1px solid var(--ln-border, rgba(0, 0, 0, 0.12));
}
.btn-secondary:hover:not(:disabled) { background: var(--ln-surface-hover, #e2e8f0); }

.btn-outline {
  background: var(--c-surface);
  color: var(--ln-text-secondary, #334155);
  border: 1px solid var(--ln-border, rgba(0, 0, 0, 0.15));
}
.btn-outline:hover:not(:disabled) { background: var(--ln-surface-hover, #f1f5f9); border-color: var(--ln-border-strong, rgba(0, 0, 0, 0.25)); }

.btn-ghost {
  background: transparent;
  color: var(--ln-text-secondary, #334155);
  border: 1px solid transparent;
}
.btn-ghost:hover:not(:disabled) { background: var(--ln-surface-hover, #f1f5f9); }

.btn-danger {
  background: #f43f5e;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 1px 3px rgba(244, 63, 94, 0.2);
}
.btn-danger:hover:not(:disabled) { background: #e11d48; }

/* ── Badge stati ────────────────────────────────────── */
.badge-arancio, .badge-verde, .badge-grigio, .badge-rosso, .badge-amber, .badge-blu {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  border-radius: 9999px;
  padding: 0.2rem 0.75rem;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.01em;
}
/* nuova / aperta */
.badge-arancio { background: var(--c-amber-100); color: var(--c-amber-700); border: 1px solid rgba(245,158,11,0.3); }
/* assegnata */
.badge-verde   { background: var(--c-verde-100);  color: var(--c-verde-700); border: 1px solid rgba(46,159,92,0.25); }
/* chiusa */
.badge-grigio  { background: var(--c-border);     color: var(--c-text-500);  border: 1px solid var(--c-border-strong); }
/* sospesa */
.badge-amber   { background: var(--c-amber-100);  color: var(--c-amber-700); border: 1px solid rgba(217,119,6,0.3); }
/* annullata */
.badge-rosso   { background: var(--c-rosso-100);  color: var(--c-rosso-700); border: 1px solid rgba(239,68,68,0.2); }
.badge-blu     { background: var(--c-blu-50);     color: var(--c-blu-700);   border: 1px solid rgba(59,130,246,0.2); }

/* ── Skeleton loader ────────────────────────────────── */
.skeleton {
  border-radius: 1.25rem;
  background: linear-gradient(90deg, var(--c-border) 25%, var(--c-border-strong) 50%, var(--c-border) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s ease-in-out infinite;
}
@keyframes shimmer {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ── Utility ────────────────────────────────────────── */
.safe-top    { padding-top: env(safe-area-inset-top); }
.safe-bottom { padding-bottom: env(safe-area-inset-bottom); }
.min-h-touch { min-height: 48px; }

.text-mobile-lg { font-size: 1.125rem; line-height: 1.65rem; }
@media (min-width: 768px) { .text-mobile-lg { font-size: 1.25rem; line-height: 1.85rem; } }

.line-clamp-1 { display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical; overflow: hidden; }
.line-clamp-2 { display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }

.divider { border: none; border-top: 1px solid var(--c-border); margin: 0; }

/* ── Animazioni ─────────────────────────────────────── */
.animate-slide-up { animation: slide-up 200ms cubic-bezier(0.16, 1, 0.3, 1) both; }
@keyframes slide-up {
  from { transform: translateY(10px); opacity: 0; }
  to   { transform: translateY(0); opacity: 1; }
}
.animate-fade-in { animation: fade-in 200ms ease both; }
@keyframes fade-in {
  from { opacity: 0; }
  to   { opacity: 1; }
}

/* ── Marquee Ticker Avvisi ── */
.animate-marquee {
  display: inline-block;
  white-space: nowrap;
  animation: marquee 30s linear infinite;
}
@keyframes marquee {
  0% { transform: translateX(0%); }
  100% { transform: translateX(-50%); }
}

